const easeInOutQuad = function (t: number , b: number, c: number, d: number) {
    t /= d/2;
    if (t < 1) {
        return c / 2 * t * t + b;
    }
    t--;
    return -c/2 * (t*(t-2) - 1) + b;
};

const scrollTo = (element: HTMLElement, to: number, duration: number) => {
    const start = element.scrollTop,
          change = to - start,
          increment = 20;
    let currentTime = 0;


    const animateScroll = function(){
        currentTime += increment;
        const val = easeInOutQuad(currentTime, start, change, duration);
        element.scrollTop = val;
        if(currentTime < duration) {
            setTimeout(animateScroll, increment);
        }
    };
    animateScroll();
}

const getScrollParent = (node: HTMLElement): HTMLElement | null => {
    if (node == null) {
        return null;
    }

    if (node.scrollHeight > node.clientHeight) {
        return node;
    } else {
        return getScrollParent(node.parentNode as HTMLElement);
    }
}

/**
 * Scroll to view port
 *
 * @param element
 */
const toViewport = (element: HTMLElement) => {
    const rect = element.getBoundingClientRect(),
          html = document.documentElement;
    const isInViewPort = (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || html.clientHeight) &&
        rect.right <= (window.innerWidth || html.clientWidth)
    );
    if (!isInViewPort) {
        const parent = getScrollParent(element) as HTMLElement;
        if (rect.bottom > (window.innerHeight || html.clientHeight)) {
            parent && (parent.scrollTop += rect.bottom - (window.innerHeight || html.clientHeight) + 60);
        }
        if (rect.top < 0) {
            parent && (parent.scrollTop += rect.top - 60);
        }
    }
}

export { scrollTo, getScrollParent, toViewport }

//t = current time
//b = start value
//c = change in value
//d = duration
